import { render, staticRenderFns } from "./ProductionOfElectricity.vue?vue&type=template&id=6e5555cc&scoped=true&"
import script from "./ProductionOfElectricity.vue?vue&type=script&lang=js&"
export * from "./ProductionOfElectricity.vue?vue&type=script&lang=js&"
import style0 from "./ProductionOfElectricity.vue?vue&type=style&index=0&id=6e5555cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5555cc",
  null
  
)

export default component.exports